import { NavigationBack, Typography } from "@/components";
import { AppBarRightIcon } from "@/components/ui";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "@tanstack/react-router";

interface AppBarGroupChatProps {
	type: "group" | "single";
	id: number;
	title: string;
	tabs: Record<"label" | "value", string>[];
	activeTab: string;
	onChangeTab: (value: string) => void;
}

const AppBarGroupChat = (props: AppBarGroupChatProps) => {
	const { type, title, id, tabs, activeTab = "all", onChangeTab } = props;

	const tabValue = tabs.findIndex((tab) => tab.value === activeTab);

	return (
		<AppBar
			position="relative"
			color="transparent"
			className="!bg-gradient-chat [&_*_]:text-white"
		>
			<Toolbar className="container !gap-4">
				<NavigationBack />
				<Link
					to={
						type === "group"
							? "/dashboard/chat/group/$id/detail"
							: "/dashboard/contacts/member/$id"
					}
					params={{ id }}
					className="flex flex-col justify-center items-start flex-1"
				>
					<Typography fontSize={14} fontWeight={600}>
						{type === "group" ? "Group Chat" : "1 to 1 Chat"}
					</Typography>
					<Typography fontSize={10} fontWeight={400}>
						{title}
					</Typography>
				</Link>
				<div>
					{type === "group" && id ? (
						<Link to="/dashboard/chat/group/$id/members" params={{ id }}>
							<IconButton color="primary">
								<PersonAddIcon className="text-default " />
							</IconButton>
						</Link>
					) : null}
					<AppBarRightIcon hideSetting />
				</div>
			</Toolbar>
			<Toolbar
				className="[&_.MuiTabs-flexContainer]:md:justify-center [&_.MuiTabs-flexContainer]:justify-normal"
				classes={{
					root: "!p-0 !items-end",
				}}
			>
				<Tabs
					value={tabValue}
					onChange={(_, val) => onChangeTab(tabs[val].value)}
					variant="scrollable"
					indicatorColor="primary"
					textColor="inherit"
					scrollButtons="auto"
					aria-label="scrollable auto tabs example chat"
					className="w-full [&_span.MuiTabs-indicator]:!bg-white"
				>
					{tabs.map((tab) => (
						<Tab
							key={tab.value}
							label={tab.label}
							sx={{ textTransform: "none" }}
						/>
					))}
				</Tabs>
			</Toolbar>
		</AppBar>
	);
};

export default AppBarGroupChat;
